<template>
  <div class="pd-10 border-box h-100 border">
    <el-row class="page uk-width-1-1">
      <div class="el-col uk-width-1-2 uk-width-2-5@xl">
        <Condition @onPreview="onPreview"></Condition>
      </div>
      <div class="el-col uk-width-1-2 uk-width-3-5@xl">
        <div class="h-100 bd-r bd-t bd-b w-100 preview">
          <div class="uk-text-center preview-title">{{ $t('public.statistic_preview') }}</div>
          <div
            class="content"
            style="height: calc(100% - 80px);overflow-y: auto"
          >
            <template v-if="previewData">
              <div
                class="statistic-item"
                v-for="(range, key) in previewData"
                :key="key"
              >
                <div class="title">
                  {{ key }}
                </div>
                <template v-for="(scene, scenekey) in range">
                  <div class="bd-l bd-t bd-r pd-10" :key="scenekey">
                    {{ scenekey }}
                  </div>

                  <div :key="'tb-' + scenekey" class="pd-10 border">
                    <table class="uk-table uk-table-striped">
                      <thead>
                        <tr>
                          <td>{{ $t('public.carrier') }}</td>
                          <td>{{ $t('public.records_passed') }}</td>
                          <td>{{ $t('text.total') }}</td>
                          <td>{{ $t('integration.total_passing_time') }}({{$t('public.minute')}})</td>
                          <td>{{ $t('integration.total_duration') }}({{$t('public.minute')}})</td>
                          <td>{{ $t('integration.pass_rate') }}</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(carrier, index) in scene"
                          :key="carrier.carrierId"
                          :style="`background: ${carrier.color}`"
                        >
                          <td>{{ carrier.carrierName }}</td>
                          <td>{{ carrier.passNum }}</td>
                          <td>{{ carrier.totalNum }}</td>
                          <td>
                            {{ (carrier.passTime / 1000 / 60).toFixed(2) }}
                          </td>
                          <td>
                            {{ (carrier.totalTime / 1000 / 60).toFixed(2) }}
                          </td>
                          <td>{{ (carrier.passRate * 100).toFixed(2) }}%</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </template>
              </div>
            </template>
            <ElEmpty v-else :description="$t('public.no_data')"></ElEmpty>
          </div>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import Condition from '@/pages/count/statistic/component/Condition.vue'

export default {
  components: {
    Condition
  },
  data () {
    return {
      previewData: null
    }
  },
  methods: {
    onPreview (data) {
      // 后端返回非对象（如错误消息字符串）时直接清空预览，避免将字符串当对象遍历导致赋值报错
      if (!data || typeof data !== 'object' || Array.isArray(data)) {
        this.previewData = null
        return
      }
      Object.keys(data).forEach(range => {
        const map = {}

        for (let i = 0; i < data[range].length; i++) {
          const carrier = data[range][i]
          if (!map[carrier.fullScene]) {
            map[carrier.fullScene] = []
          }
          map[carrier.fullScene].push(carrier)
        }

        data[range] = map
      })
      console.log(data)
      this.previewData = data
    }
  }
}
</script>

<style lang="scss" scoped>
.pd-10 {
  ::v-deep .page.el-row,
  ::v-deep .el-col {
    height: 100% !important;
  }
}

.preview {
  .preview-title {
    font-size: 16px;
    font-weight: bolder;
    line-height: 50px;
    border-bottom: solid #ccc 1px;
  }

  .content {
    padding: 10px;
  }

  .statistic-item {
    margin-bottom: 10px;

    .title {
      text-align: center;
      border: solid #ccc 1px;
      border-bottom: none;
      line-height: 40px;
    }
  }
}

.uk-table {
  border: #ccc 1px solid;
  text-align: center;
}
</style>
